// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Montserrat:500,700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* stylelint-disable-next-line import-notation */
/* ---------- Mobile Max Width ----------- */
/* ---------- Mobile Min-Max Width ----------- */
/* ---------- Desktop ------------------- */
/* ---------- Desktop Low Res ------------------- */
/* ------------------- Text Styles --------------------------------------------------------- */
/* ------------------- Scrollbar --------------------------------------------------------- */
html {
  font-size: 10px;
}

a {
  color: #0e52b7;
  outline: none;
  text-decoration: none;
}

* {
  font-family: montserrat, sans-serif;
  -webkit-tap-highlight-color: transparent;
  font-size: 1.6rem;
  line-height: 1.5;
}
* > strong, * span {
  font-size: inherit;
  line-height: inherit;
}

span, p, a, input, textarea, ul, ol, li, div {
  font-weight: 500;
}

ul > li:not(:last-child), ol > li:not(:last-child) {
  padding-bottom: 1.2rem;
}

h1, h2, h3, h4, h5 {
  line-height: 1.25;
}

h1 {
  font-size: 4.8rem;
}
@media screen and (width >= 720px) and (width <= 1023px) {
  h1 {
    font-size: 4rem;
  }
}
@media screen and (width <= 719px) {
  h1 {
    font-size: 3.2rem;
  }
}

h2 {
  font-size: 3.6rem;
}
@media screen and (width >= 720px) and (width <= 1023px) {
  h2 {
    font-size: 3.2rem;
  }
}
@media screen and (width <= 719px) {
  h2 {
    font-size: 2.6rem;
  }
}

h3 {
  font-size: 2.8rem;
}
@media screen and (width >= 720px) and (width <= 1023px) {
  h3 {
    font-size: 2.4rem;
  }
}
@media screen and (width <= 719px) {
  h3 {
    font-size: 2.2rem;
  }
}

h4 {
  font-size: 2.4rem;
}
@media screen and (width >= 720px) and (width <= 1023px) {
  h4 {
    font-size: 2.2rem;
  }
}
@media screen and (width <= 719px) {
  h4 {
    font-size: 2rem;
  }
}

h5 {
  font-size: 1.8rem;
}

.small {
  font-size: 1.2rem;
  line-height: 1.5;
}

.small-2 {
  font-size: 1rem;
  line-height: 1.5;
}
.small-2 > * {
  font-size: inherit;
  line-height: inherit;
}
@media screen and (width <= 719px) {
  .small-2 {
    font-size: 1.2rem;
  }
}

.medium {
  font-weight: 500;
}

.semi-bold {
  font-weight: 600;
}

.bold {
  font-weight: 700;
}

.blue-text {
  color: #0e52b7;
}

.black-text {
  color: #000;
}

.white-text {
  color: #fff;
}

.red-text {
  color: #be1e2d;
}

.link {
  text-decoration: underline;
  cursor: pointer;
}
.link:hover {
  opacity: 0.75;
}

.uppercase-text {
  text-transform: uppercase;
}

.components-kit-wrapper {
  width: 100vw;
  margin-top: 6rem;
}
@media screen and (width >= 720px) {
  .components-kit-wrapper {
    padding: 2.4rem;
  }
}
@media screen and (width <= 719px) {
  .components-kit-wrapper {
    padding: 1.6rem;
  }
}
.components-kit-wrapper > * {
  display: flex;
  align-items: flex-start;
  border: 1px solid #bdbdbd;
}
@media screen and (width >= 720px) {
  .components-kit-wrapper > * {
    padding: 2.4rem;
  }
}
@media screen and (width <= 719px) {
  .components-kit-wrapper > * {
    padding: 1.6rem;
  }
}
.components-kit-wrapper > *:not(:last-child) {
  margin-bottom: 2.4rem;
}
.components-kit-wrapper .typography-kit {
  flex-direction: column;
}
.components-kit-wrapper .typography-kit * {
  outline: 1px dashed #bdbdbd;
}
.components-kit-wrapper .typography-kit *:not(:last-child) {
  margin-bottom: 1.2rem;
}
.components-kit-wrapper .padding-kit {
  justify-content: space-between;
}
.components-kit-wrapper .padding-kit > * {
  outline: 1px dashed #bdbdbd;
  background: #95c900;
}
.components-kit-wrapper .padding-kit > * div {
  width: 4.8rem;
  height: 4.8rem;
  background: #fff;
}
.components-kit-wrapper .padding-kit > * div::after {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
@media screen and (width >= 720px) {
  .components-kit-wrapper .padding-kit .padding-12 {
    padding: 1.2rem;
  }
}
@media screen and (width >= 384px) and (width <= 719px) {
  .components-kit-wrapper .padding-kit .padding-12 {
    padding: 0.8rem;
  }
}
@media screen and (width >= 720px) {
  .components-kit-wrapper .padding-kit .padding-12 div::after {
    content: "12px";
  }
}
@media screen and (width >= 384px) and (width <= 719px) {
  .components-kit-wrapper .padding-kit .padding-12 div::after {
    content: "8px";
  }
}
@media screen and (width >= 720px) {
  .components-kit-wrapper .padding-kit .padding-24 {
    padding: 2.4rem;
  }
}
@media screen and (width <= 719px) {
  .components-kit-wrapper .padding-kit .padding-24 {
    padding: 1.6rem;
  }
}
@media screen and (width >= 720px) {
  .components-kit-wrapper .padding-kit .padding-24 div::after {
    content: "24px";
  }
}
@media screen and (width >= 384px) and (width <= 719px) {
  .components-kit-wrapper .padding-kit .padding-24 div::after {
    content: "16px";
  }
}
@media screen and (width >= 720px) {
  .components-kit-wrapper .padding-kit .padding-48 {
    padding: 4.8rem;
  }
}
@media screen and (width >= 384px) and (width <= 719px) {
  .components-kit-wrapper .padding-kit .padding-48 {
    padding: 3.2rem;
  }
}
@media screen and (width >= 720px) {
  .components-kit-wrapper .padding-kit .padding-48 div::after {
    content: "48px";
  }
}
@media screen and (width >= 384px) and (width <= 719px) {
  .components-kit-wrapper .padding-kit .padding-48 div::after {
    content: "32px";
  }
}
@media screen and (width >= 720px) {
  .components-kit-wrapper .padding-kit .padding-96 {
    padding: 9.6rem;
  }
}
@media screen and (width >= 384px) and (width <= 719px) {
  .components-kit-wrapper .padding-kit .padding-96 {
    padding: 6.4rem;
  }
}
@media screen and (width >= 720px) {
  .components-kit-wrapper .padding-kit .padding-96 div::after {
    content: "96px";
  }
}
@media screen and (width >= 384px) and (width <= 719px) {
  .components-kit-wrapper .padding-kit .padding-96 div::after {
    content: "64px";
  }
}
.components-kit-wrapper .icons-kit {
  justify-content: space-between;
  flex-wrap: wrap;
}
.components-kit-wrapper .icons-kit img {
  width: 2.4rem;
  height: 2.4rem;
}
.components-kit-wrapper .buttons-kit {
  padding: 0;
}
.components-kit-wrapper .buttons-kit section {
  width: 50%;
  display: flex;
  flex-direction: column;
  background: #f2f2f2;
}
@media screen and (width >= 720px) {
  .components-kit-wrapper .buttons-kit section {
    padding: 2.4rem;
  }
}
@media screen and (width <= 719px) {
  .components-kit-wrapper .buttons-kit section {
    padding: 1.6rem;
  }
}
.components-kit-wrapper .buttons-kit section:last-child {
  background: #0f426b;
}
.components-kit-wrapper .buttons-kit section > *:not(:last-child) {
  margin-bottom: 2.4rem;
}
.components-kit-wrapper .phone-number-kit {
  padding: 0;
}
.components-kit-wrapper .phone-number-kit .old-phone-number-component .input-text-component,
.components-kit-wrapper .phone-number-kit .old-phone-number-component .dropdown-component,
.components-kit-wrapper .phone-number-kit .old-phone-number-component .phone-number-component {
  width: 100%;
}
.components-kit-wrapper .phone-number-kit .old-phone-number-component .country {
  max-width: 10rem;
}
.components-kit-wrapper .phone-number-kit .old-phone-number-component .area {
  max-width: 7rem;
}
.components-kit-wrapper .phone-number-kit .old-phone-number-component .number {
  max-width: 14rem;
}
.components-kit-wrapper .phone-number-kit section {
  width: 50%;
  display: flex;
  flex-direction: column;
  background: #f2f2f2;
}
@media screen and (width >= 720px) {
  .components-kit-wrapper .phone-number-kit section {
    padding: 2.4rem;
  }
}
@media screen and (width <= 719px) {
  .components-kit-wrapper .phone-number-kit section {
    padding: 1.6rem;
  }
}
.components-kit-wrapper .phone-number-kit section > *:not(:last-child) {
  margin-bottom: 2.4rem;
}
.components-kit-wrapper .registration-table-section {
  display: block;
  width: 100%;
}
.components-kit-wrapper .address-kit {
  padding: 0;
}
.components-kit-wrapper .address-kit section {
  width: 50%;
  display: flex;
  flex-direction: column;
  background: #f2f2f2;
}
@media screen and (width >= 720px) {
  .components-kit-wrapper .address-kit section {
    padding: 2.4rem;
  }
}
@media screen and (width <= 719px) {
  .components-kit-wrapper .address-kit section {
    padding: 1.6rem;
  }
}
.components-kit-wrapper .address-kit section > *:not(:last-child) {
  margin-bottom: 2.4rem;
}
.components-kit-wrapper .address-kit .old-address-wrapper .input-text-component,
.components-kit-wrapper .address-kit .old-address-wrapper .dropdown-component,
.components-kit-wrapper .address-kit .old-address-wrapper .phone-number-component {
  width: 100%;
}
.components-kit-wrapper .address-kit .old-address-wrapper .inputs-area {
  width: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  flex-wrap: wrap;
}
.components-kit-wrapper .address-kit .old-address-wrapper .inputs-area > * {
  width: calc(50% - 1.2rem);
  margin-bottom: 3.2rem;
}
.components-kit-wrapper .address-kit .old-address-wrapper .info-wrapper,
.components-kit-wrapper .address-kit .old-address-wrapper .contact-info-wrapper {
  width: 100%;
  max-width: 70rem;
}
.components-kit-wrapper .address-kit .old-address-wrapper .info-wrapper h5,
.components-kit-wrapper .address-kit .old-address-wrapper .contact-info-wrapper h5 {
  display: flex;
  align-items: center;
  margin-bottom: 1.2rem;
}
.components-kit-wrapper .address-kit .old-address-wrapper .info-wrapper h5 .custom-tool-tip,
.components-kit-wrapper .address-kit .old-address-wrapper .contact-info-wrapper h5 .custom-tool-tip {
  margin-left: 1.2rem;
}
@media screen and (width <= 719px) {
  .components-kit-wrapper .address-kit .old-address-wrapper {
    padding: 4.8rem 0;
  }
  .components-kit-wrapper .address-kit .old-address-wrapper .inputs-area {
    flex-direction: column;
  }
  .components-kit-wrapper .address-kit .old-address-wrapper .inputs-area > * {
    width: 100%;
    max-width: 100%;
  }
}
.components-kit-wrapper .dropdown-kit {
  padding: 0;
}
.components-kit-wrapper .dropdown-kit > section {
  width: 50%;
}
@media screen and (width >= 720px) {
  .components-kit-wrapper .dropdown-kit > section {
    padding: 2.4rem;
  }
}
@media screen and (width <= 719px) {
  .components-kit-wrapper .dropdown-kit > section {
    padding: 1.6rem;
  }
}
.components-kit-wrapper .dropdown-kit > section:last-child {
  background: #0f426b;
}
.components-kit-wrapper .selectors-kit {
  padding: 0;
}
.components-kit-wrapper .selectors-kit > section {
  width: 50%;
}
@media screen and (width >= 720px) {
  .components-kit-wrapper .selectors-kit > section {
    padding: 2.4rem;
  }
}
@media screen and (width <= 719px) {
  .components-kit-wrapper .selectors-kit > section {
    padding: 1.6rem;
  }
}
.components-kit-wrapper .selectors-kit > section:last-child {
  background: #0f426b;
}
.components-kit-wrapper .selectors-kit > section > *:not(:last-child) {
  margin-bottom: 2.4rem;
}
.components-kit-wrapper .selectors-kit > section form > *:not(:last-child) {
  margin-bottom: 2.4rem;
}
.components-kit-wrapper .fields-kit {
  padding: 0;
}
.components-kit-wrapper .fields-kit > section {
  width: 50%;
}
@media screen and (width >= 720px) {
  .components-kit-wrapper .fields-kit > section {
    padding: 2.4rem;
  }
}
@media screen and (width <= 719px) {
  .components-kit-wrapper .fields-kit > section {
    padding: 1.6rem;
  }
}
.components-kit-wrapper .fields-kit > section:last-child {
  background: #0f426b;
}
.components-kit-wrapper .fields-kit > section > *:not(:last-child) {
  margin-bottom: 2.4rem;
}
.components-kit-wrapper .fields-kit > section form > *:not(:last-child) {
  margin-bottom: 2.4rem;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/typography.scss","webpack://./src/assets/styles/mixins/common.scss","webpack://./src/kit/scenes/UIComponentsScene/index.scss","webpack://./src/assets/styles/variables.scss"],"names":[],"mappings":"AAGA,gDAAA;ACDA,4CAAA;AAOA,gDAAA;AAOA,2CAAA;AAOA,mDAAA;AAOA,8FAAA;AAuEA,4FAAA;AD/FA;EACE,eAAA;AEGF;;AFAA;EACE,cGFiB;EHGjB,aAAA;EACA,qBAAA;AEGF;;AFAA;EACE,mCAAA;EACA,wCAAA;EACA,iBAAA;EACA,gBAAA;AEGF;AFDE;EACE,kBAAA;EACA,oBAAA;AEGJ;;AFCA;EACE,gBAAA;AEEF;;AFEE;EACE,sBAAA;AECJ;;AFGA;EACE,iBAAA;AEAF;;AFGA;EACE,iBAAA;AEAF;AFEE;EAHF;IAII,eAAA;EECF;AACF;AFCE;EAPF;IAQI,iBAAA;EEEF;AACF;;AFCA;EACE,iBAAA;AEEF;AFAE;EAHF;IAII,iBAAA;EEGF;AACF;AFDE;EAPF;IAQI,iBAAA;EEIF;AACF;;AFDA;EACE,iBAAA;AEIF;AFFE;EAHF;IAII,iBAAA;EEKF;AACF;AFHE;EAPF;IAQI,iBAAA;EEMF;AACF;;AFHA;EACE,iBAAA;AEMF;AFJE;EAHF;IAII,iBAAA;EEOF;AACF;AFLE;EAPF;IAQI,eAAA;EEQF;AACF;;AFLA;EACE,iBAAA;AEQF;;AFLA;EACE,iBAAA;EACA,gBAAA;AEQF;;AFLA;EACE,eAAA;EACA,gBAAA;AEQF;AFNE;EACE,kBAAA;EACA,oBAAA;AEQJ;AFLE;EATF;IAUI,iBAAA;EEQF;AACF;;AFLA;EACE,gBAAA;AEQF;;AFLA;EACE,gBAAA;AEQF;;AFLA;EACE,gBAAA;AEQF;;AFLA;EACE,cGrHiB;AD6HnB;;AFLA;EACE,WGjHW;ADyHb;;AFLA;EACE,WGzGW;ADiHb;;AFLA;EACE,cG9HS;ADsIX;;AFLA;EACE,0BAAA;EACA,eAAA;AEQF;AFNE;EACE,aAAA;AEQJ;;AFJA;EACE,yBAAA;AEOF;;AAlJA;EACE,YAAA;EACA,gBAAA;AAqJF;ADjJE;ECNF;IDyCI,eAAA;ECkHF;AACF;ADpKE;ECQF;ID6CI,eAAA;ECmHF;AACF;AA3JE;EAbA,aAAA;EACA,uBAAA;EACA,yBAAA;AA2KF;ADhKE;ECAA;IDmCE,eAAA;ECiIF;AACF;ADnLE;ECcA;IDuCE,eAAA;ECkIF;AACF;AAvKI;EACE,qBAAA;AAyKN;AArKE;EACE,sBAAA;AAuKJ;AArKI;EACE,2BAAA;AAuKN;AArKM;EACE,qBAAA;AAuKR;AAlKE;EACE,8BAAA;AAoKJ;AAlKI;EACE,2BAAA;EACA,mBC3BO;AD+Lb;AAlKM;EACE,aAAA;EACA,cAAA;EACA,gBCnBK;ADuLb;AAlKQ;EACE,kBAAA;EACA,SAAA;EACA,QAAA;EACA,gCAAA;AAoKV;ADxME;ECyCE;IDhBA,eAAA;ECmLF;AACF;ADpNE;ECgDE;IDZA,eAAA;ECoLF;AACF;ADlNE;EC6CM;IACE,eAAA;EAwKR;AACF;AD9NE;EC0DM;IACE,cAAA;EAuKR;AACF;AD5NE;ECyDE;IDtBA,eAAA;EC6LF;AACF;AD/OE;ECuEE;IDlBA,eAAA;EC8LF;AACF;ADtOE;EC6DM;IACE,eAAA;EA4KR;AACF;ADlPE;EC0EM;IACE,eAAA;EA2KR;AACF;ADhPE;ECyEE;ID5BA,eAAA;ECuMF;AACF;AD5PE;ECgFE;IDxBA,eAAA;ECwMF;AACF;AD1PE;EC6EM;IACE,eAAA;EAgLR;AACF;ADtQE;EC0FM;IACE,eAAA;EA+KR;AACF;ADpQE;ECyFE;IDlCA,eAAA;ECiNF;AACF;ADhRE;ECgGE;ID9BA,eAAA;ECkNF;AACF;AD9QE;EC6FM;IACE,eAAA;EAoLR;AACF;AD1RE;EC0GM;IACE,eAAA;EAmLR;AACF;AA9KE;EACE,8BAAA;EACA,eAAA;AAgLJ;AA9KI;EACE,aAAA;EACA,cAAA;AAgLN;AA5KE;EACE,UAAA;AA8KJ;AA5KI;EACE,UAAA;EACA,aAAA;EACA,sBAAA;EACA,mBCtHO;ADoSb;ADzSE;ECuHE;IDpFA,eAAA;EC0QF;AACF;AD5TE;ECqIE;IDhFA,eAAA;EC2QF;AACF;AApLM;EACE,mBCxIa;AD8TrB;AAnLM;EACE,qBAAA;AAqLR;AAhLE;EACE,UAAA;AAkLJ;AA/KM;;;EAGE,WAAA;AAiLR;AA9KM;EACE,gBAAA;AAgLR;AA7KM;EACE,eAAA;AA+KR;AA5KM;EACE,gBAAA;AA8KR;AA1KI;EACE,UAAA;EACA,aAAA;EACA,sBAAA;EACA,mBC/JO;AD2Ub;ADhVE;ECgKE;ID7HA,eAAA;ECiTF;AACF;ADnWE;EC8KE;IDzHA,eAAA;ECkTF;AACF;AAlLM;EACE,qBAAA;AAoLR;AA/KE;EACE,cAAA;EACA,WAAA;AAiLJ;AA9KE;EACE,UAAA;AAgLJ;AA9KI;EACE,UAAA;EACA,aAAA;EACA,sBAAA;EACA,mBCrLO;ADqWb;AD1WE;ECsLE;IDnJA,eAAA;EC2UF;AACF;AD7XE;ECoME;ID/IA,eAAA;EC4UF;AACF;AAtLM;EACE,qBAAA;AAwLR;AAnLM;;;EAGE,WAAA;AAqLR;AAlLM;EACE,WAAA;EACA,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,eAAA;AAoLR;AAlLQ;EACE,yBAAA;EACA,qBAAA;AAoLV;AAhLM;;EAEE,WAAA;EACA,gBAAA;AAkLR;AAhLQ;;EACE,aAAA;EACA,mBAAA;EACA,qBAAA;AAmLV;AAjLU;;EACE,mBAAA;AAoLZ;ADpaE;ECiNE;IAqCI,iBAAA;EAkLN;EAhLM;IACE,sBAAA;EAkLR;EAhLQ;IACE,WAAA;IACA,eAAA;EAkLV;AACF;AA5KE;EACE,UAAA;AA8KJ;AA5KI;EACE,UAAA;AA8KN;ADxaE;ECyPE;IDtNA,eAAA;ECyYF;AACF;AD3bE;ECuQE;IDlNA,eAAA;EC0YF;AACF;AApLM;EACE,mBCvQa;AD6brB;AAjLE;EACE,UAAA;AAmLJ;AAjLI;EACE,UAAA;AAmLN;AD3bE;ECuQE;IDpOA,eAAA;EC4ZF;AACF;AD9cE;ECqRE;IDhOA,eAAA;EC6ZF;AACF;AAzLM;EACE,mBCrRa;ADgdrB;AAxLM;EACE,qBAAA;AA0LR;AAtLQ;EACE,qBAAA;AAwLV;AAlLE;EACE,UAAA;AAoLJ;AAlLI;EACE,UAAA;AAoLN;ADpdE;EC+RE;ID5PA,eAAA;ECqbF;AACF;ADveE;EC6SE;IDxPA,eAAA;ECsbF;AACF;AA1LM;EACE,mBC7Sa;ADyerB;AAzLM;EACE,qBAAA;AA2LR;AAvLQ;EACE,qBAAA;AAyLV","sourcesContent":["@use '@Styles/variables';\n\n// TODO when we switch to create-react-app we need to standardize this\n/* stylelint-disable-next-line import-notation */\n@import url('https://fonts.googleapis.com/css?family=Montserrat:500,700&display=swap');\n\nhtml {\n  font-size: 10px;\n}\n\na {\n  color: variables.$primaryBlueColor;\n  outline: none;\n  text-decoration: none;\n}\n\n* {\n  font-family: montserrat, sans-serif;\n  -webkit-tap-highlight-color: transparent;\n  font-size: 1.6rem;\n  line-height: 1.5;\n\n  &>strong, span{\n    font-size: inherit;\n    line-height: inherit;\n  }\n}\n\nspan, p, a, input, textarea, ul, ol, li, div {\n  font-weight: 500;\n}\n\nul, ol{\n  &>li:not(:last-child){\n    padding-bottom: 1.2rem;\n  }\n}\n\nh1, h2, h3, h4, h5 {\n  line-height: 1.25;\n}\n\nh1 {\n  font-size: 4.8rem;\n\n  @media screen and (width >= 720px) and (width <= 1023px) {\n    font-size: 4rem;\n  }\n\n  @media screen and (width <= 719px) {\n    font-size: 3.2rem;\n  }\n}\n\nh2 {\n  font-size: 3.6rem;\n\n  @media screen and (width >= 720px) and (width <= 1023px) {\n    font-size: 3.2rem;\n  }\n\n  @media screen and (width <= 719px) {\n    font-size: 2.6rem;\n  }\n}\n\nh3 {\n  font-size: 2.8rem;\n\n  @media screen and (width >= 720px) and (width <= 1023px) {\n    font-size: 2.4rem;\n  }\n\n  @media screen and (width <= 719px) {\n    font-size: 2.2rem;\n  }\n}\n\nh4 {\n  font-size: 2.4rem;\n\n  @media screen and (width >= 720px) and (width <= 1023px) {\n    font-size: 2.2rem;\n  }\n\n  @media screen and (width <= 719px) {\n    font-size: 2rem;\n  }\n}\n\nh5 {\n  font-size: 1.8rem;\n}\n\n.small {\n  font-size: 1.2rem;\n  line-height: 1.5;\n}\n\n.small-2 {\n  font-size: 1rem;\n  line-height: 1.5;\n\n  &>*{\n    font-size: inherit;\n    line-height: inherit;\n  }\n\n  @media screen and (width <= 719px) {\n    font-size: 1.2rem;\n  }\n}\n\n.medium {\n  font-weight: 500;\n}\n\n.semi-bold {\n  font-weight: 600;\n}\n\n.bold {\n  font-weight: 700;\n}\n\n.blue-text {\n  color: variables.$primaryBlueColor;\n}\n\n.black-text {\n  color: variables.$blackColor;\n}\n\n.white-text {\n  color: variables.$whiteColor;\n}\n\n.red-text {\n  color: variables.$redColor;\n}\n\n.link{\n  text-decoration: underline;\n  cursor: pointer;\n\n  &:hover{\n    opacity: 0.75;\n  }\n}\n\n.uppercase-text {\n  text-transform: uppercase;\n\n}\n","@use '../variables';\n\n/* ---------- Mobile Max Width ----------- */\n@mixin for-mobile-max-width {\n  @media screen and (width <= 719px) {\n    @content;\n  }\n}\n\n/* ---------- Mobile Min-Max Width ----------- */\n@mixin for-mobile-min-max-width {\n  @media screen and (width >= 384px) and (width <= 719px) {\n    @content;\n  }\n}\n\n/* ---------- Desktop ------------------- */\n@mixin for-desktop-screen {\n  @media screen and (width >= 720px) {\n    @content;\n  }\n}\n\n/* ---------- Desktop Low Res ------------------- */\n@mixin for-low-res-desktop-screen {\n  @media screen and (width <= 1020px) and (width >= 720px) {\n    @content;\n  }\n}\n\n/* ------------------- Text Styles --------------------------------------------------------- */\n@mixin module-title {\n  letter-spacing: -0.02em;\n  color: #11195b;\n  font-family: nunitosemibold, sans-serif;\n  font-style: normal;\n  font-weight: bold;\n  font-size: 18px;\n  line-height: 36px;\n}\n\n@mixin padding-12 {\n  @include for-desktop-screen {\n    padding: 1.2rem;\n  }\n\n  @include for-mobile-min-max-width {\n    padding: 0.8rem;\n  }\n}\n\n@mixin padding-24 {\n  @include for-desktop-screen {\n    padding: 2.4rem;\n  }\n\n  @include for-mobile-max-width {\n    padding: 1.6rem;\n  }\n}\n\n@mixin padding-48 {\n  @include for-desktop-screen {\n    padding: 4.8rem;\n  }\n\n  @include for-mobile-min-max-width {\n    padding: 3.2rem;\n  }\n}\n\n@mixin padding-96 {\n  @include for-desktop-screen {\n    padding: 9.6rem;\n  }\n\n  @include for-mobile-min-max-width {\n    padding: 6.4rem;\n  }\n}\n\n@mixin text-overflow($width, $max-width) {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  max-width: $max-width;\n  width: $width;\n}\n\n@mixin bottom-border-divider {\n  border-bottom: 1px solid variables.$grayColor8;\n}\n\n// Does Not Work In IE11, But 98% Other Browsers\n@mixin multiline-ellipsis($lines) {\n  overflow: hidden;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: $lines;\n}\n\n/* ------------------- Scrollbar --------------------------------------------------------- */\n@mixin scrollbars($size, $bar-color, $track-color) {\n  /* Browsers without `::-webkit-scrollbar-*` support */\n  @supports not selector(::-webkit-scrollbar) {\n    scrollbar-width: thin;\n    scrollbar-color: $bar-color $track-color;\n  }\n\n  // For Safari\n  &::-webkit-scrollbar {\n    height: $size;\n    width: $size;\n    background: hsl(0deg, 0%, 87.1%, 0.8471);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: $bar-color;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: $track-color;\n  }\n\n  // For Internet Explorer\n  & {\n    scrollbar-face-color: $bar-color;\n    scrollbar-track-color: $track-color;\n  }\n}\n","@use '@Styles/mixins/common';\n@use '@Styles/variables';\n@use '@Styles/typography';\n\n@mixin base-styles {\n  display: flex;\n  align-items: flex-start;\n  border: 1px solid variables.$grayColor4;\n\n  @include common.padding-24;\n}\n\n.components-kit-wrapper {\n  width: 100vw;\n  margin-top: 6rem;\n\n  @include common.padding-24;\n\n  & > * {\n    @include base-styles;\n\n    &:not(:last-child) {\n      margin-bottom: 2.4rem;\n    }\n  }\n\n  .typography-kit {\n    flex-direction: column;\n\n    * {\n      outline: 1px dashed variables.$grayColor4;\n\n      &:not(:last-child) {\n        margin-bottom: 1.2rem;\n      }\n    }\n  }\n\n  .padding-kit {\n    justify-content: space-between;\n\n    & > * {\n      outline: 1px dashed variables.$grayColor4;\n      background: variables.$greenColor;\n\n      div {\n        width: 4.8rem;\n        height: 4.8rem;\n        background: variables.$whiteColor;\n\n        &::after {\n          position: absolute;\n          left: 50%;\n          top: 50%;\n          transform: translate(-50%, -50%);\n        }\n      }\n    }\n\n    .padding-12 {\n      @include common.padding-12;\n\n      @include common.for-desktop-screen {\n        div::after {\n          content: '12px';\n        }\n      }\n\n      @include common.for-mobile-min-max-width {\n        div::after {\n          content: '8px';\n        }\n      }\n    }\n\n    .padding-24 {\n      @include common.padding-24;\n\n      @include common.for-desktop-screen {\n        div::after {\n          content: '24px';\n        }\n      }\n\n      @include common.for-mobile-min-max-width {\n        div::after {\n          content: '16px';\n        }\n      }\n    }\n\n    .padding-48 {\n      @include common.padding-48;\n\n      @include common.for-desktop-screen {\n        div::after {\n          content: '48px';\n        }\n      }\n\n      @include common.for-mobile-min-max-width {\n        div::after {\n          content: '32px';\n        }\n      }\n    }\n\n    .padding-96 {\n      @include common.padding-96;\n\n      @include common.for-desktop-screen {\n        div::after {\n          content: '96px';\n        }\n      }\n\n      @include common.for-mobile-min-max-width {\n        div::after {\n          content: '64px';\n        }\n      }\n    }\n  }\n\n  .icons-kit {\n    justify-content: space-between;\n    flex-wrap: wrap;\n\n    img {\n      width: 2.4rem;\n      height: 2.4rem;\n    }\n  }\n\n  .buttons-kit {\n    padding: 0;\n\n    section {\n      width: 50%;\n      display: flex;\n      flex-direction: column;\n      background: variables.$grayColor6;\n\n      @include common.padding-24;\n\n      &:last-child {\n        background: variables.$secondaryBlueColor;\n      }\n\n      & > *:not(:last-child) {\n        margin-bottom: 2.4rem;\n      }\n    }\n  }\n\n  .phone-number-kit {\n    padding: 0;\n\n    .old-phone-number-component {\n      .input-text-component,\n      .dropdown-component,\n      .phone-number-component {\n        width: 100%;\n      }\n\n      .country {\n        max-width: 10rem;\n      }\n\n      .area {\n        max-width: 7rem;\n      }\n\n      .number {\n        max-width: 14rem;\n      }\n    }\n\n    section {\n      width: 50%;\n      display: flex;\n      flex-direction: column;\n      background: variables.$grayColor6;\n\n      @include common.padding-24;\n\n      & > *:not(:last-child) {\n        margin-bottom: 2.4rem;\n      }\n    }\n  }\n\n  .registration-table-section {\n    display: block;\n    width: 100%;\n  }\n\n  .address-kit {\n    padding: 0;\n\n    section {\n      width: 50%;\n      display: flex;\n      flex-direction: column;\n      background: variables.$grayColor6;\n\n      @include common.padding-24;\n\n      & > *:not(:last-child) {\n        margin-bottom: 2.4rem;\n      }\n    }\n\n    .old-address-wrapper {\n      .input-text-component,\n      .dropdown-component,\n      .phone-number-component {\n        width: 100%;\n      }\n\n      .inputs-area {\n        width: 100%;\n        display: flex;\n        align-items: flex-start;\n        justify-content: space-between;\n        flex-wrap: wrap;\n\n        & > * {\n          width: calc(50% - 1.2rem);\n          margin-bottom: 3.2rem;\n        }\n      }\n\n      .info-wrapper,\n      .contact-info-wrapper {\n        width: 100%;\n        max-width: 70rem;\n\n        h5 {\n          display: flex;\n          align-items: center;\n          margin-bottom: 1.2rem;\n\n          .custom-tool-tip {\n            margin-left: 1.2rem;\n          }\n        }\n      }\n\n      @include common.for-mobile-max-width {\n        padding: 4.8rem 0;\n\n        .inputs-area {\n          flex-direction: column;\n\n          & > * {\n            width: 100%;\n            max-width: 100%;\n          }\n        }\n      }\n    }\n  }\n\n  .dropdown-kit {\n    padding: 0;\n\n    & > section {\n      width: 50%;\n\n      @include common.padding-24;\n\n      &:last-child {\n        background: variables.$secondaryBlueColor;\n      }\n    }\n  }\n\n  .selectors-kit {\n    padding: 0;\n\n    & > section {\n      width: 50%;\n\n      @include common.padding-24;\n\n      &:last-child {\n        background: variables.$secondaryBlueColor;\n      }\n\n      & > *:not(:last-child) {\n        margin-bottom: 2.4rem;\n      }\n\n      form {\n        & > *:not(:last-child) {\n          margin-bottom: 2.4rem;\n        }\n      }\n    }\n  }\n\n  .fields-kit {\n    padding: 0;\n\n    & > section {\n      width: 50%;\n\n      @include common.padding-24;\n\n      &:last-child {\n        background: variables.$secondaryBlueColor;\n      }\n\n      & > *:not(:last-child) {\n        margin-bottom: 2.4rem;\n      }\n\n      form {\n        & > *:not(:last-child) {\n          margin-bottom: 2.4rem;\n        }\n      }\n    }\n  }\n}\n","@use 'sass:map';\n\n$themeMap: null;\n$adminPrimaryBlueColor: #4254f9;\n$adminPrimaryTextColor: #595e8d;\n$adminComponentsShadow: 0 5px 20px rgba(22, 33, 133, 0.05);\n$adminListItemsPadding: 22px;\n$adminTextColor: #595e8d;\n$adminTitleSecondaryColor: #4a6507;\n$primaryBlueColor: #0e52b7;\n$secondaryBlueColor: #0f426b;\n$hoverBlueColor: #2676ed;\n$redColor: #be1e2d;\n$redLightColor: #dd5050;\n$orangeColor: #e27538;\n$yellowColor: #ffd200;\n$greenColor: #95c900;\n$blackColor: #000;\n$grayColor1: #333;\n$grayColor2: #4f4f4f;\n$grayColor3: #828282;\n$grayColor4: #bdbdbd;\n$grayColor5: #e0e0e0;\n$grayColor6: #f2f2f2;\n$grayColor7: #bebebe;\n$grayColor8: #dadada;\n$greyColorForBorder: #c4c4c4;\n$greyColorForTableHeader: #585858;\n$backgroundGrey: #f9f9f9;\n$whiteColor: #fff;\n$offWhiteColor: #fafafa;\n$creamColor: #f9f9f9;\n$sidebarWidth: 31rem;\n$statusIncompleteColor: #ffd200;\n$statusSubmittedColor: #ffd200;\n$statusPendingColor: #55bfff;\n$statusAcceptedColor: #95c900;\n$statusPartiallyAcceptedColor: darkblue;\n$statusRejectedColor: #be1e2d;\n$statusSupersededColor: #ad00ff;\n$overclaimStatusColor: #ffd200;\n$disputeStatusColor: #be1e2d;\n$closedStatusColor: #95c900;\n$mergedStatusColor: #0e52b7;\n$canceledStatusColor: #4f4f4f;\n$filterPrimaryBlue: invert(24%) sepia(76%) saturate(1733%) hue-rotate(201deg) brightness(92%) contrast(104%);\n$filterSecondaryBlue: invert(17%) sepia(25%) saturate(5155%) hue-rotate(189deg) brightness(91%) contrast(88%);\n$filterHoverBlue: invert(34%) sepia(83%) saturate(3609%) hue-rotate(208deg) brightness(103%) contrast(86%);\n$filterRed: invert(17%) sepia(64%) saturate(4146%) hue-rotate(342deg) brightness(90%) contrast(94%);\n$filterRedLight: invert(32%) sepia(63%) saturate(972%) hue-rotate(320deg) brightness(113%) contrast(88%);\n$filterOrange: invert(53%) sepia(57%) saturate(622%) hue-rotate(336deg) brightness(92%) contrast(93%);\n$filterYellow: invert(85%) sepia(27%) saturate(4207%) hue-rotate(359deg) brightness(105%) contrast(104%);\n$filterGreen: invert(75%) sepia(49%) saturate(3003%) hue-rotate(30deg) brightness(94%) contrast(111%);\n$filterGray1: invert(19%) sepia(0%) saturate(0%) hue-rotate(57deg) brightness(97%) contrast(94%);\n$filterGray2: invert(27%) sepia(43%) saturate(0%) hue-rotate(198deg) brightness(97%) contrast(91%);\n$filterGray3: invert(52%) sepia(0%) saturate(671%) hue-rotate(147deg) brightness(98%) contrast(80%);\n$filterGray4: invert(90%) sepia(0%) saturate(1315%) hue-rotate(136deg) brightness(89%) contrast(79%);\n$filterGray5: invert(80%) sepia(99%) saturate(0%) hue-rotate(138deg) brightness(92%) contrast(101%);\n$filterGray6: invert(100%) sepia(5%) saturate(192%) hue-rotate(202deg) brightness(115%) contrast(90%);\n$filterWhite: invert(100%) sepia(100%) saturate(0%) hue-rotate(288deg) brightness(102%) contrast(102%);\n$filterNoOp: initial;\n$themes: (\n  member-standard: (\n    navigation-primary-background: $grayColor6,\n    navigation-secondary-background: $whiteColor,\n    navigation-tertiary-background: $primaryBlueColor,\n    navigation-inverse-background: $primaryBlueColor,\n    navigation-primary-text: $blackColor,\n    navigation-secondary-text: $primaryBlueColor,\n    navigation-inverse-text: $whiteColor,\n    navigation-primary-filter: $filterPrimaryBlue,\n    navigation-primary-border: 1px solid $grayColor5,\n    navigation-account-badge-display: block,\n  ),\n  songwriter-standard: (\n    navigation-primary-background: $secondaryBlueColor,\n    navigation-secondary-background: $secondaryBlueColor,\n    navigation-tertiary-background: $primaryBlueColor,\n    navigation-inverse-background: $whiteColor,\n    navigation-primary-text: $whiteColor,\n    navigation-secondary-text: $whiteColor,\n    navigation-inverse-text: $primaryBlueColor,\n    navigation-primary-filter: $filterWhite,\n    navigation-primary-border: 1px solid $primaryBlueColor,\n    navigation-account-badge-display: none,\n  ),\n);\n\n@mixin themed() {\n  @each $theme, $map in $themes {\n    .theme--#{$theme} & {\n      $themeMap: () !global;\n\n      @each $key, $submap in $map {\n        $value: map.get(map.get($themes, $theme), '#{$key}');\n        $themeMap: map.merge(\n          $themeMap,\n          (\n            $key: $value,\n          )\n        ) !global;\n      }\n      @content;\n\n      $themeMap: null !global;\n    }\n  }\n}\n\n@function theme($key) {\n  @return map.get($themeMap, $key);\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
